module.exports = __webpack_public_path__ + "static/img/360ee.3bdb8e26.png";